import React from 'react'
import { getFiltrosModalMobileStyles } from '../utils/styles'
import Modal from 'react-modal'
import closeResponsiveModal from '../../assets/img/close-form-comer-modal.svg'

const DetallePedidoMobileModal = (
  {
    isOpen,
    setIsOpen,
    onRequestClose,
    distanceToToModales,
    title = '',
    rows = [],
  }
) => {
  const closeModal = () => {
    if (setIsOpen) {
      setIsOpen(false)
    }

    if (onRequestClose) {
      onRequestClose()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={getFiltrosModalMobileStyles(distanceToToModales)}
    >
      <div className='detalle-forma-comercializacion-modal-container'>
        <div className="header-data-forma-comer-modal-header-container">
          <div className="hedaer-title-area">
            <div className="hedaer-label">
              Detalle Forma Comercialización
            </div>
            <img src={closeResponsiveModal} alt="" onClick={closeModal} />
          </div>
          <div className="sub-title-area">
            {title}
          </div>
        </div>
        
        <div className="forma-comer-modal-area-separator">
        </div>

        <div className="table-container">
          <table className='detalle-mobile-table'>
            <thead>
              <tr>
                <th>Tipo Detalle</th>
                <th className="align-right">Detalle</th>
              </tr>
            </thead>
              <tr className="separator-table-row">
                <th colSpan="100%" />
              </tr>
              <tbody>
              {rows.length > 0 && rows.map((row, index) => (
                <tr className="data" key={`${row.label}-${row.value}`}>
                  <td className="align-left">
                    {row.label}
                  </td>
                  <td className="align-right">
                    {row.value}
                  </td>
                </tr>
              ))}

              {rows.length === 0 && (
                <tr className="data">
                  <td className="align-left" colSpan="100%">
                    Sin datos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        </div>

        <div className="action-area-container">
          <button className="main-button" onClick={closeModal}>
            Cerrar
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default DetallePedidoMobileModal